import Color from 'color';
import {
  OL_HOVER_DARKEN_AMOUNT,
  OL_HOVER_LIGHTEN_AMOUNT,
} from '../components/Style/colours';

// add is deprecated in SASS
export const probablyCorrectDeprecatedSassColorAdd = (
  a: string,
  b: string
): string => {
  const colorA = new Color(a);
  const colorB = new Color(b);
  return new Color(a)
    .red(colorA.red() + colorB.red())
    .green(colorA.green() + colorB.green())
    .blue(colorA.blue() + colorB.blue())
    .hex();
};

// subtract is deprecated in SASS
export const probablyCorrectDeprecatedSassColorSubtract = (
  a: string,
  b: string
): string => {
  const colorA = new Color(a);
  const colorB = new Color(b);
  return new Color(a)
    .red(colorA.red() - colorB.red())
    .green(colorA.green() - colorB.green())
    .blue(colorA.blue() - colorB.blue())
    .hex();
};

export const rgba = (hex: string, opacity: number): string => {
  const color = new Color(hex);
  return `rgba(${color.red()}, ${color.green()}, ${color.blue()}, ${opacity})`;
};

export const mix = (
  color1: string,
  color2: string,
  weightForColor1: number
): string => {
  return new Color(color1).mix(new Color(color2), 1 - weightForColor1).hex();
};

export const darken = (color: string, darkenAmount: number): string => {
  return new Color(color).darken(darkenAmount).hex();
};

export const lighten = (color: string, lightenAmount: number): string => {
  // Note that the code below is using the lighten function from Color, the
  // result would be different from mixing white with input colour (i.e.
  // new Color(color).mix(new Color('white'), lightenAmount).hex())
  return new Color(color).lighten(lightenAmount).hex();
};

export const hoverLighten = (color: string): string => {
  return new Color(color).lighten(OL_HOVER_LIGHTEN_AMOUNT).hex();
};

export const hoverDarken = (color: string): string => {
  return new Color(color).darken(OL_HOVER_DARKEN_AMOUNT).hex();
};
